"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNormalizedSegment = exports.SEGMENT = void 0;
exports.SEGMENT = {
    PARTICULARES: 'particulares',
    GP: 'gp',
    EMP: 'emp',
    PLUS: 'plus',
    EMPRESAS: 'empresas',
};
const normalizeSegmentValue = (finalSegment) => {
    let segmentNormalized = finalSegment;
    segmentNormalized = segmentNormalized.toLowerCase();
    switch (segmentNormalized) {
        case 'empresas':
        case 'emp':
            return exports.SEGMENT.EMP;
        case 'plus':
        case 'movistarplus':
            return exports.SEGMENT.PLUS;
        default:
            return exports.SEGMENT.GP;
    }
};
function getNormalizedSegment(segmentProp) {
    // 0. Recogemos el valor del segmento de la aplicacion en curso
    const segmentEnv = process.env.NEXT_PUBLIC_ENV_SEGMENT;
    // 1. Inicializo el resultado de la función
    let finalSegment = segmentEnv;
    // 2. Decidimos si confiar en la variable de entorno o el la propiedad del componente
    if (segmentProp) {
        finalSegment = segmentProp;
    }
    if (!segmentEnv && !segmentProp) {
        finalSegment = 'gp';
    }
    // 3. Normalizamos el valor para que siempre tenga la misma estructura/patron/forma/apariencia...
    finalSegment = normalizeSegmentValue(finalSegment);
    return finalSegment;
}
exports.getNormalizedSegment = getNormalizedSegment;
;
exports.default = exports.SEGMENT;
//# sourceMappingURL=index.js.map